/**
 * <pdp-price>
 *
 * PDP price block. Updates the regular/compare price (and the optional EU-Omnibus
 * "lowest price in last 30 days") when the selected variant changes. Reads the
 * formatted values off the section's pdp:variant-update event (sourced from the
 * canonical [data-variants-data] in <main-product>), so there is no per-block
 * variant parsing.
 */

class PdpPrice extends HTMLElement {
  #host = null;
  #priceRegular = null;
  #priceCompare = null;
  #lowestPrice = null;

  connectedCallback() {
    this.#host = this.closest('main-product');
    this.#priceRegular = this.querySelector('[data-price-regular]');
    this.#priceCompare = this.querySelector('[data-price-compare]');
    this.#lowestPrice = this.querySelector('[data-product-info-lowest-price]');

    this.#host?.addEventListener('pdp:variant-update', this.#onVariantUpdate);
  }

  disconnectedCallback() {
    this.#host?.removeEventListener('pdp:variant-update', this.#onVariantUpdate);
  }

  #onVariantUpdate = (event) => {
    const variant = event.detail?.variant;
    if (!variant) return;

    if (this.#priceRegular && variant.price_formatted) {
      this.#priceRegular.textContent = variant.price_formatted;
    }

    if (this.#priceCompare) {
      const compare = variant.compare_at_price_formatted;
      const showCompare = compare && variant.compare_at_price > variant.price;
      this.#priceCompare.textContent = showCompare ? compare : '';
      this.#priceCompare.toggleAttribute('hidden', !showCompare);
    }

    if (this.#lowestPrice && typeof variant.lowest_price_formatted !== 'undefined') {
      const lp = variant.lowest_price_formatted;
      const lpSpan = this.#lowestPrice.querySelector('[data-lowest-price]');
      if (lpSpan) lpSpan.textContent = lp ?? '';
      this.#lowestPrice.toggleAttribute('hidden', !lp);
    }
  };
}

if (!customElements.get('pdp-price')) {
  customElements.define('pdp-price', PdpPrice);
}
